export default function (req, res, next) {
    // Check if the url is not the root and does not end with a slash
    const queryIndex = req.url.indexOf('?');
    const hasQuery = queryIndex !== -1;
    const path = hasQuery ? req.url.substring(0, queryIndex) : req.url;
    if (path === '/') {
        next();
        return;
    }

    if (hasQuery || req?.url?.endsWith('/')) {
        if (!path?.endsWith('/')) {
            next();
            return;
        }
        const query = hasQuery ? req.url.substring(queryIndex) : '';
        const withoutSlash = `${path.slice(0, -1)}` + query;
        res.writeHead(301, { Location: withoutSlash });
        res.end();
    } else {
        next();
    }
}
